import 'react-native-get-random-values'; // for crypto-js
import CryptoJS from 'crypto-js';

import * as _hm from './_hm';
import * as _ht from './_ht';

export const ect = (
  vle: _ht.a, 
  srt?: _ht.s,
) => {
  if (!srt) {
    return vle;
  }
  else {
    const _srt = srt ?? 'hogehoge';
    return CryptoJS.AES.encrypt(_hm.s({tgt: vle}), _srt).toString(); // not sure, but you have to wrap the value with object and stringify them.
  }
};

export const dct = (
  vle: _ht.a, 
  srt?: _ht.s,
) => {
  if (!srt) {
    return vle;
  }
  else {
    const _srt = srt ?? 'hogehoge';
    const _s = CryptoJS.AES.decrypt(vle, _srt).toString(CryptoJS.enc.Utf8);
    return _hm.j(_s)?.tgt;
  }
};
